import { FunctionComponent } from 'react'
import { WParagraph } from '@alice-health/wonderland-react'
import { Phone } from '@/modules/accredited-establishments/api/types'
import { RouteLink } from '@/modules/accredited-establishments/components/RouteLink'
import { RouteDestination } from '@/modules/accredited-establishments/types/RouteDestination'
import { ContactSection } from '../ContactSection'

interface ProviderInfoSectionProps {
  remote?: boolean
  address?: RouteDestination[]
  phones?: Phone[]
  isCassi?: boolean
}

/*
 * Corpo da secao Atendimento nos dois drawers de detalhe (nodes 26:40868 e
 * 26:41637): modalidade remota, enderecos e contato, um bloco por linha. O
 * `first:pt-0` encosta o primeiro bloco no titulo da secao.
 */
const BLOCK = 'py-gl-spacing-06 first:pt-0'

const ProviderInfoSection: FunctionComponent<ProviderInfoSectionProps> = ({
  remote = false,
  isCassi = false,
  address,
  phones
}) => {
  const addresses = address ?? []
  const hasContact = Boolean(phones?.length) || isCassi

  return (
    <div className='flex flex-col divide-y divide-sys-color-stroke-idle'>
      {remote ? (
        <div className={BLOCK}>
          <WParagraph className='mb-2'>Online</WParagraph>

          <WParagraph mode='tertiary'>
            Esta instituição oferece consultas online, permitindo que você seja
            atendido diretamente da sua casa
          </WParagraph>
        </div>
      ) : null}

      {addresses.length ? (
        <div className={`flex flex-col gap-gl-spacing-06 ${BLOCK}`}>
          {addresses.map((item, index) => (
            <div key={item.address}>
              <WParagraph className='mb-2'>
                {addresses.length > 1 ? `Endereço ${index + 1}` : 'Endereço'}
              </WParagraph>

              <WParagraph mode='tertiary'>{item.address}</WParagraph>

              {/*
               * `block w-fit`: a ancora do AppLink e inline, entao sem isso a
               * margem superior nao se aplica e a caixa do botao herda a
               * largura do bloco de endereco.
               */}
              <RouteLink
                className='mt-gl-spacing-04 block w-fit'
                destination={item}
              />
            </div>
          ))}
        </div>
      ) : null}

      {hasContact ? (
        <div className={BLOCK}>
          <ContactSection
            phones={phones}
            isCassi={isCassi}
          />
        </div>
      ) : null}
    </div>
  )
}

export type { ProviderInfoSectionProps }

export { ProviderInfoSection }
